<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', () => {
  const estimators = document.querySelectorAll('[data-shipping-estimator]');
  if (!estimators.length) return;

  const API_URL = 'https://api.tiomusa.com.ar/envio';
  const TIMEOUT_MS = 12000;

  estimators.forEach((root) => {
    const btn = root.querySelector('[data-calc-shipping]');
    const zipInput = root.querySelector('[data-zip]');
    const resultBox = root.querySelector('[data-shipping-result]');
    if (!btn || !zipInput || !resultBox) return;

    btn.addEventListener('click', async () => {
      const zip = (zipInput.value || '').trim();
      if (!zip) {
        resultBox.textContent = 'Ingresá tu código postal';
        return;
      }

      const sku = document.querySelector('.productView-info-value')?.textContent.trim();
      if (!sku) {
        resultBox.textContent = 'No se pudo detectar el SKU';
        return;
      }

      // 🔹 Obtener quantity desde input[name="quantity"]
      const qtyInput = document.querySelector('input[name="quantity"]');
      let quantity = parseInt(qtyInput?.value, 10);

      if (!quantity || quantity < 1 || Number.isNaN(quantity)) {
        quantity = 1;
      }

      const controller = new AbortController();
      const t = setTimeout(() => controller.abort(), TIMEOUT_MS);

      btn.disabled = true;
      resultBox.textContent = 'Calculando envío…';

      try {
        const params = new URLSearchParams({
          sku,
          quantity,
          zip
        });

        const res = await fetch(`${API_URL}?${params.toString()}`, {
          method: 'GET',
          signal: controller.signal,
        });

        if (!res.ok) {
          const text = await res.text().catch(() => '');
          throw new Error(`HTTP ${res.status}. ${text.slice(0, 200)}`);
        }

        const data = await res.json();

        // 🔹 Render seguro (por si no hay days)
        let html = `<strong>Envío:</strong> $${data.cost}`;

        if (data.currency_id) {
          html += ` ${data.currency_id}`;
        }

        if (data.days) {
          html += ` – <strong>Entrega:</strong> ${data.days} días`;
        }

        resultBox.innerHTML = html;
      } catch (e) {
        const msg =
          e.name === 'AbortError'
            ? 'El servicio tardó demasiado en responder. Probá nuevamente.'
            : 'No se pudo calcular el envío.';
        console.error('Shipping estimator error:', e);
        resultBox.textContent = msg;
      } finally {
        clearTimeout(t);
        btn.disabled = false;
      }
    });
  });
});


  document.addEventListener('DOMContentLoaded', function() {
    const menuLinks = document.querySelectorAll('header a, nav a');
    menuLinks.forEach(link => {
      if (link.textContent.trim() === 'Ventas Mayoristas') {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
      }
    });
  });

